export const formatData = (data: any) => {
    return data
        .map((item: any) => ({
            label: `${item.city || ''}, ${item.street || ''} ${item.house_number || ''} (${item.id})`.trim(),
            value: item.id,
            pickup_allowed: item.pickup_allowed,
            cod_allowed: item.cod_allowed,
            country_id: item.country_id,
        }))
        .sort((a: any, b: any): any => `${a.label}`.localeCompare(`${b.label}`));
};



export const formatDataCountries = (data: any) => {
    return data.items
        .map((item: any): any => {
            return {
                label: item.name,
                value: item.id,
                iso: item.iso,
                cod_allowed: item.cod_allowed,
            };
        })
        .sort((a: any, b: any): any => `${a.label}`.localeCompare(`${b.label}`));
};
